module.exports = __webpack_public_path__ + "static/media/Biiggie.741f3c70.jpg";